export default {
  'adb-filter': {
    collapseAll: 'Collapse All',
    expandAll: 'Expand All',
    SelectAll: 'Select All',
    minimumAmount: 'Minimum Amount',
    maximumAmount: 'Maximum Amount',
    minimumNumber: 'Minimum Number',
    maximumNumber: 'Maximum Number',
    startDate: 'Start Date',
    endDate: 'End Date',
    searchBy: 'Search by ',
    pleaseSelect: 'Please select',
    lastWeek: 'Last Week',
    lastMonth: 'Last Month',
    last3Month: 'Last 3 Month',
    clearFilter: 'clear filter',
    clearAll: 'Clear All Filters',
    saveFilter: 'save filter',
    commitFilter: 'Confirm',
    filterTitle: 'Filters',
  },
};
